import { secondarySearch } from "../components/indexDB/indexDBStora";

export async function CheckUserAtt (date, code = '', mode = "boolean") {
    const getToday = await secondarySearch("schedule", "date", date);
    if(mode !== "boolean") {
        return getToday;
    } 
    if(getToday.length === 0) {
        return false;
    }
    const findTody = getToday.find((item) => item.code === code);
    if(findTody) {
        return true;
    }
    
    return false;
}
